import { commonUtils } from '../common_utils';

const SANTANDER_MIN_LOAN_AMOUNT = 2000;
const SANTANDER_MAX_LOAN_AMOUNT = 50000;

export const santander = {
    removeGreenEffect() {
        $('.greenFadeEffect').removeClass('updateSec');
    },
    loadYear(defaultYears) {
        $('#loan_period').empty();
        let startYear = 2;
        let endYear = $('#loan_amount').val() > 500 ? 10 : 5;

        for (let year = startYear; year <= endYear; year++) {
            $('#loan_period').append(new Option(year, year));
        }

        $('#loan_period').val(defaultYears);
    },
    calculateInterestRate(timePeriod, estimateMonthlyPayment, rate) {
        return (parseFloat(estimateMonthlyPayment) * (1 - (1 + parseFloat(rate)) ** -timePeriod)) / parseFloat(rate);
    },
    getInterestRate(timePeriod, estimateMonthlyPayment, amount) {
        let index = 0,
            lowValue = 0,
            highValue = 1,
            rate = 0.5;
        let calculateRate = santander.calculateInterestRate(timePeriod, estimateMonthlyPayment, rate);

        while (Math.abs(parseInt(amount, 10) - parseInt(calculateRate, 10)) > 0.001) {
            rate = (parseFloat(lowValue) + parseFloat(highValue)) / 2;
            calculateRate = santander.calculateInterestRate(timePeriod, estimateMonthlyPayment, rate);

            if (amount > calculateRate) {
                highValue = rate;
            } else {
                lowValue = rate;
            }

            index++;
            if (index > 100) {
                return rate;
            }
        }

        return rate;
    },
    calculateRate(amountInput, timePeriod) {
        let amount = amountInput;
        // loan interest rate in %
        let intRate;
        if (amount >= 2000 && amount <= 5000) {
            intRate = 9.9;
        } else if (amount >= 5001 && amount <= 20000) {
            intRate = 9;
        } else if (amount >= 20001 && amount <= 40000) {
            intRate = 8;
        } else if (amount >= 40001 && amount <= 50000) {
            intRate = 5;
        }

        // Euribor loan interest rate in %
        let euribor = 3.937;

        // Opening Fee in €
        let openingFee = (amount >= 2000 && amount <= 5000) ? 0 : 49;

        // Statement fee
        let statementFee = (amount >= 2000 && amount <= 5000) ? 0 : 8;

        // Loan Amount should be between 2K to 50K
        if (amount < SANTANDER_MIN_LOAN_AMOUNT) {
            amount = SANTANDER_MIN_LOAN_AMOUNT;
        }
        if (amount > SANTANDER_MAX_LOAN_AMOUNT) {
            amount = SANTANDER_MAX_LOAN_AMOUNT;
        }

        // Calculate interest Rate
        let interestRate = (parseFloat(intRate) + parseFloat(euribor)) / (12 * 100);
        // Calculate Monthly Payment
        let monthlyPayment = Math.ceil(
            (parseFloat(interestRate) * (parseInt(amount, 10) + parseInt(openingFee, 10))) /
                (1 - (1 + parseFloat(interestRate)) ** -timePeriod) +
                parseInt(statementFee, 10)
        );
        let estimateMonthlyPayment =
            (parseFloat(interestRate) * (parseInt(amount, 10) + parseInt(openingFee, 10))) /
                (1 - (1 + parseFloat(interestRate)) ** -timePeriod) +
            parseInt(statementFee, 10);

        // Calculate Rate and using that value calculate Annual Interest rate
        let calculateRate = santander.getInterestRate(timePeriod, estimateMonthlyPayment + 1, amount);
        let annualInterestRate = ((1 + parseFloat(calculateRate)) ** 12 - 1) * 100;

        return {
            monthlyPayment,
            annualInterestRate: annualInterestRate.toFixed(2),
            monthlyInterestRate: parseFloat(intRate) + parseFloat(euribor),
        };
    },
    slider() {
        let defaultYear = $('#loan_period').val();
        let defaultMonths = defaultYear * 12;
        let loanAmount = $('#loan_amount').val();

        $('.greenFadeEffect').addClass('updateSec');

        if (loanAmount < SANTANDER_MIN_LOAN_AMOUNT) {
            alert(Translations.ad_detail.finance.error.santander_min_loan_amount);
            loanAmount = SANTANDER_MIN_LOAN_AMOUNT;
            $('#loan_amount').val(loanAmount);
        }

        if (loanAmount > SANTANDER_MAX_LOAN_AMOUNT) {
            alert(Translations.ad_detail.finance.error.santander_max_loan_amount);
            loanAmount = SANTANDER_MAX_LOAN_AMOUNT;
            $('#loan_amount').val(loanAmount);
        }

        let loanData = santander.calculateRate(loanAmount, defaultMonths);
        let monthlyPayment =
            loanAmount > 0 && defaultYear > 0 ? commonUtils.numberFormatByLocale(loanData.monthlyPayment) : 0;

        $('#monthly_payment').html(monthlyPayment);
        $('#air').html(commonUtils.numberFormatByLocale(loanData.annualInterestRate));
        $('#mir').html(commonUtils.numberFormatByLocale(loanData.monthlyInterestRate));

        setTimeout(santander.removeGreenEffect, 1000);
    },
    submit(object) {
        commonUtils.dataLayer.getLoanButtonDataLayerEvent(object.data('bank-name'));

        let loanAmount = $('#loan_amount').val();
        let loanMonth = $('#loan_period').val() * 12;
        let loanUrl = `https://santanderconsumer.fi/laina/hakemus/?bid=1108&la=${loanAmount}&lp=${loanMonth}`;

        window.open(loanUrl, '_blank');
    },
};
